module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319058.35921abe.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319058.pdf
// module id = 832
// module chunks = 0